"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.owSoftwareUpgradeProposalOptions = exports.owOptionalTimestamp = exports.owOptionalAny = exports.owOptionalLong = exports.owLong = exports.owTextProposalOptions = exports.owCancelSoftwareUpgradeProposalOptions = exports.owParamChangeProposalOptions = exports.owParamChange = exports.owCommunityPoolSpendProposalOptions = void 0;
var ow_1 = __importDefault(require("ow"));
var long_1 = __importDefault(require("long"));
var ow_types_1 = require("../../../ow.types");
var ow_types_2 = require("../../../coin/ow.types");
exports.owCommunityPoolSpendProposalOptions = ow_types_1.owStrictObject().exactShape({
    title: ow_1.default.string,
    description: ow_1.default.string,
    recipient: ow_1.default.string,
    amount: ow_types_2.owCoin(),
});
exports.owParamChange = function () {
    return ow_types_1.owStrictObject().exactShape({
        subspace: ow_1.default.string,
        key: ow_1.default.string,
        value: ow_1.default.string,
    });
};
exports.owParamChangeProposalOptions = ow_types_1.owStrictObject().exactShape({
    title: ow_1.default.string,
    description: ow_1.default.string,
    paramChanges: ow_1.default.array.ofType(exports.owParamChange()),
});
exports.owCancelSoftwareUpgradeProposalOptions = ow_types_1.owStrictObject().exactShape({
    title: ow_1.default.string,
    description: ow_1.default.string,
});
exports.owTextProposalOptions = ow_types_1.owStrictObject().exactShape({
    title: ow_1.default.string,
    description: ow_1.default.string,
});
var owLongValidator = function (val) { return ({
    validator: val instanceof long_1.default,
    message: function (label) { return "Expected " + label + " to be an instance of `Long`"; },
}); };
exports.owLong = function () { return ow_types_1.owStrictObject().validate(owLongValidator); };
exports.owOptionalLong = function () { return ow_types_1.owOptionalStrictObject().validate(owLongValidator); };
exports.owOptionalAny = function () {
    return ow_types_1.owOptionalStrictObject().exactShape({
        typeUrl: ow_1.default.string,
        value: ow_1.default.uint8Array,
    });
};
exports.owOptionalTimestamp = function () {
    return ow_types_1.owOptionalStrictObject().exactShape({
        seconds: exports.owOptionalLong(),
        nanos: ow_1.default.optional.number,
    });
};
exports.owSoftwareUpgradeProposalOptions = ow_types_1.owStrictObject().exactShape({
    title: ow_1.default.string,
    description: ow_1.default.string,
    plan: ow_1.default.object.exactShape({
        name: ow_1.default.string,
        time: exports.owOptionalTimestamp(),
        height: exports.owLong(),
        info: ow_1.default.string,
        upgradedClientState: exports.owOptionalAny(),
    }),
});
//# sourceMappingURL=ow.types.js.map